<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12" v-if="loaded == false">
                    <loading />
                </div>

                <template v-else>
                    <div class="col-sm-12 col-md-12 col-lg-12" v-if="customerRequestProductWarranty.length < 1">
                        <h5 class="text-center mt-5">You have no warranty claim requests.</h5>
                    </div>

                    <div
                        class="col-sm-12 col-md-6 col-lg-4 col-xl-3"
                        v-bind:key="'product_' + index"
                        v-for="(product, index) in customerRequestProductWarranty"
                    >
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="registered-product-item excerpt-card">
                                    <div class="product-item-head customer">
                                        <TicketIcon :ticket_status="product.ticket_status" :ticket_type="product.ticket_type" />
                                        <router-link
                                            class="btn btn-primary card-view"
                                            :to="{name: 'CustomerRegisteredProductEdit', params: {id: product.id}}"
                                        >
                                            VIEW
                                        </router-link>
                                    </div>
                                    <ul>
                                        <li>
                                            <span class="semibold">model:</span> <span class="normal">{{ product.product_model }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">serial number:</span>
                                            <span class="normal">{{ product.sku_with_serial_number }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">date purchased:</span> <span class="normal">{{ product.installation_date }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">place of purchase:</span>
                                            <span class="normal">{{ product.place_of_purchase }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">coc number:</span> <span class="normal">{{ product.coc_number }} </span>
                                        </li>
                                        <li>
                                            <span class="semibold">coc certificate:</span>
                                            <span v-if="product.coc_certificate"
                                                ><a href="#" class="normal" @click.prevent="viewCocCertificate(product)">View</a></span
                                            >
                                            <span class="normal" v-else>--n/a--</span>
                                        </li>

                                        <li>
                                            <span class="semibold">purchased from:</span>
                                            <span class="normal">{{ product.purchased_from ? product.purchased_from.company : '---' }} </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';
import TicketIcon from '@/components/TicketIcon.vue';

export default {
    name: 'registerProductCustomerWarrantyActive',
    components: {
        TicketIcon
    },
    data() {
        return {
            loaded: true,
            active_registered_products: [],
            currentPage: 1,
            pageNavs: []
        };
    },

    computed: {
        customerRequestProductWarranty() {
            return this.active_registered_products;
            // return this.vg_registered_products.filter((item) => {
            //     return item.open_ticket_request || item.has_open_ticket;
            // });
        },

        ...mapGetters({
            vg_registered_products: 'customer_reg_products/list',
            vg_loggedIn_user_id: 'auth/userid'
        })
    },

    mounted() {
        this.fetchRegProducts();
    },

    methods: {
        /**
         * Fetch reg products
         */
        async fetchRegProducts() {
            this.loaded = false;
            const url = `${Env.baseUrl}/customer/reg-product/has-warranty-history`;
            AuthApis.getApi(url)
                .then(async (res) => {
                    this.active_registered_products = res.data.payload;
                    this.pageNavs = res.data.nav;
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = true;
                });
        },

        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.fetchRegProducts();
        },

        /**
         * Delete product
         */
        // deleteThis(product) {
        //     this.$confirm({
        //         title: `DELETE?`,
        //         message: 'Are you sure you want to delete ' + product.sku_with_serial_number,
        //         button: {
        //             no: 'No',
        //             yes: 'Yes'
        //         },
        //         callback: (confirm) => {
        //             if (confirm) {
        //                 const url = `${Env.baseUrl}/customer/reg-product/delete/${product.id}`;
        //                 AuthApis.deleteApi(url)
        //                     .then(async (res) => {
        //                         this.fetchRegProducts();
        //                         this.$toasted.global.success({
        //                             message: 'Successfully deleted.'
        //                         });
        //                     })
        //                     .catch((err) => {
        //                         this.$toasted.global.error({
        //                             message: 'Failed, please try again later.'
        //                         });
        //                     });
        //             }
        //         }
        //     });
        // },

        viewCocCertificate(obj) {
            this.va_pdfModal(true);
            this.va_pdfModalObj(obj);
        },

        ...mapActions({
            va_setRegProducts: 'customer_reg_products/setList',
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
